import { render } from "./FullReportTableUsers.vue?vue&type=template&id=c68bbf70&scoped=true"
import script from "./FullReportTableUsers.vue?vue&type=script&lang=js"
export * from "./FullReportTableUsers.vue?vue&type=script&lang=js"

import "./FullReportTableUsers.vue?vue&type=style&index=0&id=c68bbf70&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c68bbf70"

export default script